// @flow
import * as React from "react";

import { CloseBtn, ModalBox } from "../../styles/Sidebar/UploadModal.styled";
import CloseIcon from "@mui/icons-material/Close";
import {
  Block,
  Box,
  CloseFullBtn,
  Details,
  EmptyWrapper,
  List,
  MainModal,
  OkIcon,
  WaitIcon,
  Person,
} from "../../styles/View/Infobar/Counterparties.styled";
import { PubManIcon } from "../../../public/icons/index";
import { nameCompiler } from "../../helpers/nameCompiler";
import {
  formatDateUA,
  formatTimeOnly,
} from "../../helpers/formateDate";

export function Counterparties({
  counterparties,
  open,
  handleClose,
}: CounterpartiesProps) {
  const filteredCounterparties = counterparties;
  return (
    <MainModal
      open={open}
      // onClose={handleClose} //close on click to backdrop
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalBox>
        <CloseBtn type="button" onClick={() => handleClose()}>
          <CloseIcon sx={{ color: "var(--black)" }} />
        </CloseBtn>
        <Box>
          {filteredCounterparties?.length === 0 ? (
            <EmptyWrapper>
              <PubManIcon />
              <p style={{ marginTop: "20px", marginBottom: "30px" }}>
                Підписанти відсутні
              </p>
            </EmptyWrapper>
          ) : (
            <List>
              {filteredCounterparties
                ?.sort((c1, c2) =>
                  c1.signatures[0]?.date > c2.signatures[0]?.date
                    ? -1
                    : +(c1.signatures[0]?.date < c2.signatures[0]?.date),
                )
                .map((counterparty, i) => (
                  <React.Fragment key={i}>
                    <Block>
                      <Details>
                        {counterparty.signatures?.length > 0 ? (
                          <OkIcon />
                        ) : (
                          <WaitIcon />
                        )}
                      </Details>
                      {counterparty.signatures?.length > 0 ? (
                        <>
                          <div>Дата:</div>
                          <Person>
                            {formatDateUA(counterparty.date)}
                            &nbsp;&nbsp;
                            <span style={{ color: "var(--dark-gray)" }}>
                              {formatTimeOnly(String(counterparty.date))}
                            </span>
                          </Person>
                          <div>Власник е-підпису: </div>
                        </>
                      ) : (
                        <div>Очікує підпису: </div>
                      )}
                      {counterparty.company?.code === "" ? (
                        <Person>{nameCompiler(counterparty.user)}</Person>
                      ) : (
                        <Person>
                          {counterparty.company?.title}
                          <br />
                          {nameCompiler(counterparty.user)}
                        </Person>
                      )}
                      {counterparty.company?.code === "" ? (
                        <div>ІПН:</div>
                      ) : (
                        <div>ЄДРПОУ:</div>
                      )}
                      {counterparty.company?.code === "" ? (
                        <Person>{counterparty.user.login}</Person>
                      ) : (
                        <Person>{counterparty.company?.code}</Person>
                      )}
                    </Block>
                  </React.Fragment>
                ))}
            </List>
          )}

          <CloseFullBtn type="button" onClick={() => handleClose()}>
            Закрити
          </CloseFullBtn>
        </Box>
      </ModalBox>
    </MainModal>
  );
}
